var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FileTransferApi from '~/api/file-transfer';
import GetFileUrlApi from '~/api/get-file-url';
import convertB64StringToByteArray from '~/utils/convertB64StringToByteArray';
const downloadFile = (fileId, bucket) => __awaiter(void 0, void 0, void 0, function* () {
    const fileTransferInfo = yield GetFileUrlApi.getUrlById(fileId, false, bucket);
    const jsonBlob = yield FileTransferApi.get(fileTransferInfo.fileTransferUrl);
    const text = yield jsonBlob.text();
    const byteCharacters = atob(yield JSON.parse(text).data);
    const byteArray = yield convertB64StringToByteArray(byteCharacters);
    return new Blob([byteArray], { type: 'application/pdf' });
});
export default downloadFile;
